// extracted by mini-css-extract-plugin
module.exports = {"bar":"progressbar_bar__1Zo0L","progress":"progressbar_progress__GSRTk","text":"progressbar_text__3U0dU"};